// Author thq
// Date 2021-12-19 23:06:13

class EmSicBoardPointSdp {
constructor({
        id = null,
        sdpIdSdm = '',
        sdpIdEoc = '',
        sdpNodeIdEoc = '',
        sdpNameEoc = '',
        sdpWarnEoc = '',
        sdpErrorEoc = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sdpIdSdm = sdpIdSdm;
    this.sdpIdEoc = sdpIdEoc;
    this.sdpNodeIdEoc = sdpNodeIdEoc;
    this.sdpNameEoc = sdpNameEoc;
    this.sdpWarnEoc = sdpWarnEoc;
    this.sdpErrorEoc = sdpErrorEoc;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new EmSicBoardPointSdp();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdpIdSdm',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.sdpIdSdm',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdpCodeSdm',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.sdpCodeSdm',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdpNameSdm',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.sdpNameSdm',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdpIdEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.sdpIdEoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdpNodeIdEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.sdpNodeIdEoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdpNameEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.sdpNameEoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdpWarnEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.sdpWarnEoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sdpErrorEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.sdpErrorEoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicBoardPointSdp.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    sdpIdSdmFilter : "",
    sdpIdEocFilter : "",
    sdpNodeIdEocFilter : "",
    sdpNameEocFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sdpIdSdmFilter',
        label: 'label.em.statusCollection.emSicBoardPointSdp.filter.sdpIdSdm',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emSicBoardModuleSdm'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'sdpIdEocFilter',
        label: 'label.em.statusCollection.emSicBoardPointSdp.filter.sdpIdEoc',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"sdpNodeIdEoc":"eocNodeId","sdpNameEoc":"name"}'
                }
        },
        {
        key: 'sdpNodeIdEocFilter',
        label: 'label.em.statusCollection.emSicBoardPointSdp.filter.sdpNodeIdEoc',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdpNameEocFilter',
        label: 'label.em.statusCollection.emSicBoardPointSdp.filter.sdpNameEoc',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sdpIdSdm',
        label: 'label.em.statusCollection.emSicBoardPointSdp.entity.sdpIdSdm',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emSicBoardModuleSdm'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'sdpIdEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.entity.sdpIdEoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"sdpNodeIdEoc":"eocNodeId","sdpNameEoc":"name","sdpWarnEoc":"eocStatusWarnGte","sdpErrorEoc":"eocStatusErrorGte"}'
                }
        },
        {
        key: 'sdpNodeIdEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.entity.sdpNodeIdEoc',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdpNameEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.entity.sdpNameEoc',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdpWarnEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.entity.sdpWarnEoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sdpErrorEoc',
        label: 'label.em.statusCollection.emSicBoardPointSdp.entity.sdpErrorEoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.em.statusCollection.emSicBoardPointSdp.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.emSicBoardPointSdp.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSicBoardPointSdp, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
